/* Visual helpers for the GrowJoy games. Badge ownership stays with kids-badges.js. */
(function () {
  'use strict';
  var BADGES = {
    'plant-hero': { name: 'Plant Hero', game: 'build-a-plant', from: 'Build a Plant' },
    'sunflower-star': { name: 'Sunflower Star', hint: 'Complete the sunflower diary' },
    'bug-explorer': { name: 'Bug Explorer', game: 'garden-rescue', from: 'Garden Rescue' },
    'water-guardian': { name: 'Water Guardian', hint: 'Complete the water challenge' },
    'eco-friend': { name: 'Eco Friend', game: 'compost-chef', from: 'Compost Chef' },
    'soil-scientist': { name: 'Soil Scientist', hint: 'Complete the soil challenge' }
  };
  var ORDER = ['plant-hero', 'sunflower-star', 'bug-explorer', 'water-guardian', 'eco-friend', 'soil-scientist'];
  var RING_COLORS = {
    'plant-hero': '#eca128', 'sunflower-star': '#48ade3', 'bug-explorer': '#8748db',
    'water-guardian': '#4caee6', 'eco-friend': '#36982d', 'soil-scientist': '#e45a4b'
  };

  function reduced() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }
  function confetti(stage) {
    if (reduced()) return;
    var box = document.createElement('div');
    box.className = 'gj-confetti';
    var colors = ['#e8463a', '#f6b81f', '#1e8fe1', '#8b4fd0', '#2f8f3e', '#ec4f86'];
    for (var i = 0; i < 46; i++) {
      var piece = document.createElement('i');
      piece.style.left = Math.random() * 100 + '%';
      piece.style.background = colors[i % colors.length];
      piece.style.animationDelay = (Math.random() * 0.8).toFixed(2) + 's';
      piece.style.animationDuration = (1.8 + Math.random() * 1.4).toFixed(2) + 's';
      box.appendChild(piece);
    }
    stage.appendChild(box);
    setTimeout(function () { box.remove(); }, 4200);
  }
  function shelf(el, srcFor) {
    el.replaceChildren();
    ORDER.forEach(function (id) {
      var badge = BADGES[id];
      var earned = window.GrowJoyBadges.has(id);
      var figure = document.createElement('figure');
      if (!earned) figure.className = 'locked';
      figure.style.setProperty('--gj-badge-ring', RING_COLORS[id]);
      var medallion = document.createElement('span');
      medallion.className = 'gj-shelf__medallion';
      var image = document.createElement('img');
      image.src = srcFor(id);
      image.alt = badge.name + (earned ? ' (earned)' : ' (locked)');
      var caption = document.createElement('figcaption');
      caption.textContent = badge.name;
      var hint = document.createElement('small');
      hint.textContent = earned ? 'Earned' : (badge.hint || (badge.from ? 'Play ' + badge.from : 'Coming soon'));
      medallion.appendChild(image);
      figure.append(medallion, caption, hint);
      el.appendChild(figure);
    });
  }
  function celebrate(options) {
    var badge = BADGES[options.badgeId];
    if (!badge || !badge.game) return;
    var wasEarned = window.GrowJoyBadges.has(options.badgeId);
    var result = window.GrowJoyBadges.complete(badge.game);
    var stars = Math.max(1, Math.min(3, options.stars || 1));
    options.overlay.replaceChildren();
    var starDisplay = document.createElement('div');
    starDisplay.className = 'gj-stars';
    starDisplay.setAttribute('role', 'img');
    starDisplay.setAttribute('aria-label', stars + ' of 3 stars');
    starDisplay.textContent = '★'.repeat(stars);
    var unearnedStars = document.createElement('span');
    unearnedStars.className = 'off';
    unearnedStars.textContent = '★'.repeat(3 - stars);
    starDisplay.appendChild(unearnedStars);
    var title = document.createElement('h2');
    title.textContent = options.title;
    var reveal = document.createElement('div');
    reveal.className = 'gj-badge-reveal';
    var image = document.createElement('img');
    image.src = options.badgeSrc;
    image.alt = '';
    var label = document.createElement('b');
    label.textContent = (wasEarned ? 'Badge: ' : 'New badge: ') + badge.name;
    var note = document.createElement('small');
    note.textContent = result.saved ? (wasEarned ? 'You already have this one!' : 'Saved on this device only') : 'Earned for this visit; browser storage is unavailable';
    reveal.append(image, label, note);
    var message = document.createElement('p');
    message.textContent = options.text;
    var actions = document.createElement('div');
    actions.className = 'gj-actions';
    var again = document.createElement('button');
    again.className = 'gj-btn';
    again.type = 'button';
    again.textContent = options.againLabel || 'Play again';
    again.addEventListener('click', options.again);
    actions.appendChild(again);
    options.overlay.append(starDisplay, title, reveal, message, actions);
    options.overlay.hidden = false;
    again.focus({ preventScroll: true });
    confetti(options.stage);
  }
  window.GrowJoyUI = { reduced: reduced, confetti: confetti, celebrate: celebrate, shelf: shelf };
})();
